export default __webpack_public_path__ + "static/media/information--tunnel-ahead--g1.546aa975.png";